import helpers from './global.js'

const globalHelpers = {
    install (Vue, options) {
        Vue.prototype.$helpers = helpers;
        Vue.helpers = helpers;
    }
}
export default globalHelpers;
